import React from 'react'
import classNames from 'classnames'

import './PageHero.css'

import Callout from '@components/Common/Callout/Callout'
import GetADemoButton from '@components/Common/Button/GetADemoButton'

const PageHero = ({ ...props }) => (
  <section className={classNames('c-page-hero', props.className)}>
    <div className='l-container l-container--md flex flex-col text-center'>
      {props.callout && (
        <Callout className='mb-8 md:mb-10' message={props.callout} />
      )}
      <h1
        className={classNames('t-h1 text-center', {
          'mt-4 md:mt-0': !props.callout || !props.description
        })}
      >
        {props.title}
      </h1>
      {props.description && (
        <p className='mt-4 text-xl text-brand-medium md:mt-5'>
          {props.description}
        </p>
      )}
      {props.button && <GetADemoButton className='self-center mt-8' />}
    </div>
  </section>
)

export default PageHero
